import clsx from "clsx";
import type { ReactNode } from "react";

interface MetricCardProps {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  /** Optional emphasis: 'accent' for the hero metric. */
  emphasis?: "default" | "accent";
  trailing?: ReactNode;
  className?: string;
}

export default function MetricCard({
  label,
  value,
  hint,
  emphasis = "default",
  trailing,
  className,
}: MetricCardProps) {
  return (
    <div
      className={clsx(
        "card p-5",
        emphasis === "accent" && "border-accent/30 bg-accent-50/40 dark:bg-accent-900/10 dark:border-accent/40",
        className,
      )}
    >
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs font-medium uppercase tracking-wider text-zinc-500 dark:text-zinc-400">
          {label}
        </p>
        {trailing}
      </div>
      <div
        className={clsx(
          "mt-2 tnum font-semibold leading-none tracking-tight",
          emphasis === "accent"
            ? "text-4xl text-accent-600 dark:text-accent-400 sm:text-5xl"
            : "text-3xl text-zinc-900 dark:text-zinc-50",
        )}
      >
        {value}
      </div>
      {hint && (
        <div className="mt-2 text-sm leading-snug text-zinc-500 dark:text-zinc-400">
          {hint}
        </div>
      )}
    </div>
  );
}
